import {Time, Util} from 'yougile-util'
import {DataObjectId, Hub} from 'yougile-model'
import {SyncCommitHandler} from '@client/sync-commit-handler'
import {Company} from '@extensions/company'
import {
  TASKS_BATCH_DELAY,
  TASKS_BATCH_SIZE
} from '../../import-from-trello/utils/create-trello-project'
import {ImportFromFileStore} from '../import-from-file-store'
import {State} from '../types'
import {processRows, ProcessRowsProps} from './process-rows'

const parseFileProgressEstimation = 0.1

const processTasksBatch = async (
  props: ProcessRowsProps & {iteration?: number}
): Promise<void> => {
  const {tableData, iteration = 1} = props
  if (!tableData.length) {
    return
  }
  const firstCards = tableData.splice(0, TASKS_BATCH_SIZE)
  await SyncCommitHandler.asyncDoInBatch(async () => {
    await processRows({...props, tableData: firstCards})
  })
  const tasksProcessed = TASKS_BATCH_SIZE * (iteration - 1) + firstCards.length
  const loadingProgress =
    parseFileProgressEstimation +
    (tasksProcessed * (1 - parseFileProgressEstimation)) /
      (tableData.length + tasksProcessed)
  props.store.setLoadingProgress(loadingProgress)
  await Util.wait(TASKS_BATCH_DELAY)
  await processTasksBatch({...props, iteration: iteration + 1})
}

export const importFile = async (
  state: State,
  store: ImportFromFileStore,
  tableData: Record<string, string>[]
): Promise<void> => {
  state.isErrorPopupOpen = false
  state.loading = true
  store.setLoadingProgress(parseFileProgressEstimation)

  const company = Company.getCurrent()
  const emptyProjectTitle = `Import ${Time.formatDateTime(Time.now())}`

  // this should be new for each import
  const projectsCache: Record<string, Hub> = {}
  const createdProjectNames: string[] = []

  const addedTasks: Record<string, DataObjectId> = {}
  const processedTasks: Record<string, boolean> = {}

  await processTasksBatch({
    state,
    store,
    company,
    tableData: [...tableData],
    tableDataOrig: tableData,
    emptyProjectTitle,
    projectsCache,
    createdProjectNames,
    addedTasks,
    processedTasks
  })
  state.loading = false
  state.imported = true
  store.setLoadingProgress(0)
  store.setIsErrorPopupVisible(false)
}
